export default {
  // setSafe: ({commit}, value: unknown) => {
  //   commit("setSafe", value);
  //   console.log("action safe", value);
  // }
};
